import { AdsAccountListResponse, AdsBulkEnablePreview, AdsBulkResult, AdsCampaignChildren, AdsCampaignEnableResult, AdsCampaignListResponse, AdsCampaignPauseResult, AdsCampaignSyncResponse, AdsHealthResponse, AdsInterestListResponse, AdsLiveSettings, AdsSettingsPreview, AdsSettingsResult, AdsStatusCheck, AdsUsedInterestsResponse, } from '@wit-support/admin-contracts';
import { ModuleRequestError, createModuleApi, moduleRequestErrorFrom, } from '@wit-support/admin-client-core';
/** Код ошибки «ответ admin-api не прошёл схему контракта». */
export const CONTRACT_MISMATCH = 'contract_mismatch';
const api = createModuleApi({ errorFormat: 'server-message' });
const BASE = '/api/ads';
const enc = encodeURIComponent;
export function setAdsCampaignsApiBaseUrl(url) {
    api.setBaseUrl(url);
}
async function request(schema, path, init) {
    const r = await api.fetchRaw(path, init);
    if (!r.ok)
        throw await moduleRequestErrorFrom(r);
    const parsed = schema.safeParse(await r.json());
    if (!parsed.success)
        throw new ModuleRequestError(CONTRACT_MISMATCH, r.status);
    return parsed.data;
}
const post = (body = {}) => ({
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
});
function qs(params) {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
        if (v === undefined || v === '' || v === false)
            continue;
        p.set(k, String(v));
    }
    const s = p.toString();
    return s ? `?${s}` : '';
}
const acc = (id) => `${BASE}/accounts/${enc(id)}`;
const LIVE_PATH = { campaign: 'campaigns', adset: 'adsets' };
export const campaignsApi = {
    health: () => request(AdsHealthResponse, `${BASE}/health`),
    accounts: () => request(AdsAccountListResponse, `${BASE}/accounts`),
    list: (accountId, q, opts = {}) => request(AdsCampaignListResponse, `${acc(accountId)}/campaigns/list${qs({ ...q })}`, opts.signal ? { signal: opts.signal } : undefined),
    children: (accountId, campaignId, day) => request(AdsCampaignChildren, `${acc(accountId)}/campaigns/${enc(campaignId)}/children${qs({ day })}`),
    sync: (accountId, campaignId) => request(AdsCampaignSyncResponse, `${acc(accountId)}/campaigns/${enc(campaignId)}/sync`, post()),
    statusCheck: (accountId, level, entityId, action) => request(AdsStatusCheck, `${acc(accountId)}/${level}/${enc(entityId)}/status-check${qs({ action })}`),
    pause: (accountId, level, entityId, body) => request(AdsCampaignPauseResult, `${acc(accountId)}/${level}/${enc(entityId)}/pause`, post(body)),
    enable: (accountId, level, entityId, body) => request(AdsCampaignEnableResult, `${acc(accountId)}/${level}/${enc(entityId)}/enable`, post(body)),
    // Правка живых настроек (S2): чтение из Meta, предпросмотр, запись.
    liveSettings: (accountId, level, entityId) => request(AdsLiveSettings, `${acc(accountId)}/${LIVE_PATH[level]}/${enc(entityId)}/settings`),
    previewSettings: (accountId, level, entityId, body) => request(AdsSettingsPreview, `${acc(accountId)}/${LIVE_PATH[level]}/${enc(entityId)}/settings/preview`, post(body)),
    applySettings: (accountId, level, entityId, body) => request(AdsSettingsResult, `${acc(accountId)}/${LIVE_PATH[level]}/${enc(entityId)}/settings`, post(body)),
    // Справочники виджетов таргетинга: поиск интересов в Meta и «уже использовали».
    searchInterests: (platformAccountId, q) => request(AdsInterestListResponse, `${BASE}/targeting/interests${qs({ platformAccountId, q })}`),
    usedInterests: (limit) => request(AdsUsedInterestsResponse, `${BASE}/interests/used${qs({ limit })}`),
    bulkPause: (accountId, body) => request(AdsBulkResult, `${acc(accountId)}/campaigns/bulk/pause`, post({ level: 'campaign', ...body })),
    bulkEnablePreview: (accountId, ids) => request(AdsBulkEnablePreview, `${acc(accountId)}/campaigns/bulk/enable-preview`, post({ level: 'campaign', ids })),
    bulkEnable: (accountId, body) => request(AdsBulkResult, `${acc(accountId)}/campaigns/bulk/enable`, post({ level: 'campaign', ...body })),
};
//# sourceMappingURL=api.js.map